"use client";

import { useCallback } from "react";
import { parseAsString } from "nuqs";
import { useQuerySearchParams } from "@/hooks/use-query-search-params";
import { ManageProject } from "../manage";

const MANAGE_PROJECT_PARAM = {
  field: "manage_project",
  parser: parseAsString.withDefault(""),
} as const;

export function useOpenManageProject() {
  const [, setParam] = useQuerySearchParams(MANAGE_PROJECT_PARAM);
  return useCallback(
    (id: string) => {
      setParam(id, { history: "replace", scroll: false });
    },
    [setParam],
  );
}

export function ProjectsManageProject() {
  const [projectId, setProjectId] = useQuerySearchParams(MANAGE_PROJECT_PARAM);
  const open = !!projectId?.trim();

  const clearParam = useCallback(() => {
    setProjectId(null, { history: "replace", scroll: false });
  }, [setProjectId]);

  return (
    <ManageProject
      open={open}
      onClose={clearParam}
      onSaved={() => {}}
      projectId={projectId || null}
    />
  );
}
